module.exports = __webpack_public_path__ + "img/home-marketegg-0.25869ebe.png";